import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  FormGroup,
  Label
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Input from '../../components/Input';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import client from '../../utils/client';
import SweetAlerts from '../../components/SweetAlerts';

const CardsReport = () => {
  const { t } = useTranslation();

  // const [status, setStatus] = useState(null);
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm();

  // const onChangeCardNr = ({ target }) => {
  //   let str = target.value;
  //   str = str.replace(/,/g, '').replace(/(\d{8})/g, '$1,');

  //   setValue('cardNrs', str);
  // };

  // const onBlurCardNr = ({ target }) => {
  //   let str = target.value;
  //   str = str.substring(0, str.length - 1);
  //   setValue('cardNrs', str);
  // };

  const onSubmit = async (formData) => {
    setError(null);
    setSuccess(null);
    setInProgress(true);

    const { error: saveError } = await client('admin-gc/cards/report', { body: formData });

    if (saveError) {
      setError(saveError.message);
    } else {
      setSuccess(true);
    }
    setInProgress(false);
  };

  return (
    <>
      <SimpleHeader name={t('club-information.title')} />
      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Cards report 2023</h3>
                </CardHeader>
                <CardBody>
                  {inProgress && <Spinner />}
                  {error && (
                    <Alert color="danger" className="mb-3">
                      {error}
                    </Alert>
                  )}
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col xs="12">
                        <FormGroup>
                          <Label>
                            Card numbers <span className="">(separated with comma ,)</span>
                          </Label>
                          <Input
                            name="cardNrs"
                            className="form-control"
                            rows="6"
                            placeholder="Ex: 12345678,87654321"
                            // onChange={onChangeCardNr}
                            // onBlur={onBlurCardNr}
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            register={register}
                            rules={{
                              required: true,
                              pattern: /^(\d{8},)*\d{8}$/
                            }}
                            error={errors.cardNrs}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="text-align-right">
                        <Button type="submit" color="success" disabled={inProgress}>
                          {inProgress && <Spinner size="sm" />} Save
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      {success && (
        <SweetAlerts title="Reported card numbers are saved" onConfirm={() => setSuccess(false)} />
      )}
    </>
  );
};

export default CardsReport;
